import {FeatureToggleStatusEnum} from "../../app-react/services/ab-testing/feature-toggle.view-model.interface";
import {IConfigInitializationParams} from "./config-initialization-params.interface";
import {KnownJackpotId} from "../../app-react/services/jackpots/jackpot.constants";


export const createDefaultConfigs = (params: IConfigInitializationParams) => {
    const {assetsMap} = params;
    return {
        "seo": {
            "categories": {
                "images": {
                    "alt": "SEO_IMAGE_CATEGORIES_ALT",
                    "title": "SEO_IMAGE_CATEGORIES_TITLE"
                }
            },
            "games": {
                "images": {
                    "alt": "SEO_IMAGE_GAME_TITLE"
                }
            }
        },
        "header": {
            "menuItemsOverride": {
                "pokerCrossBrandMenuItem": {
                    "display": true,
                    "text": "poker",
                    "menuItemIcon": "appHeaderPokerIcon",
                    "menuItemIconAltText": "CROSS_POKER_ICON_ALT_TEXT",
                },
                "sportCrossBrandMenuItem": {
                    "display": true,
                    "text": "sport",
                    "menuItemIcon": "appHeaderSportIcon",
                },
                "casinoCrossBrandMenuItem": {
                    "display": true
                }
            },
            "header_buttons": {
                "languages": {
                    "display": false
                },
                "help": {
                    "display": true
                },
                "search": {
                    "display": true
                }
            },
            "top_header_right": [
                "state-cross-brand",
                "app-safezone",
                "state-selection-button",
                "app-client-settings",
                "app-help-button",
            ],
            "top_header_left": [
                "search-box-form",
                "app-responsible-icons"
            ],
            "cross_brand": {
                "defaultValue": [],
                "statements": [
                    {
                        "condition": "AND",
                        "rules": [
                            {
                                "id": "deviceType",
                                "operator": "equal",
                                "value": "pc"
                            }
                        ],
                        "value": ["pokerCrossBrandMenuItem", "sportCrossBrandMenuItem"]
                    }
                ]
            }
        },
        "adminBanner": {
            "enabled": false
        },
        "onboardingTour": {
            "featureToggle": FeatureToggleStatusEnum.Enabled,
            "enabledAccordingToRegistrationTime": true,
            "stepIds": [
                "welcomeStep",
                "mainMenuStep",
                "userMenuStep"
            ]
        },
        "SDK": {
            "debug": false,
            "Analytics": {
                "GTMContainerID": "GTM-PQ2ZJ7J",
                "UATrackingID": "UA-66227773-1",
                "awaitForDataLayer": "true"
            }
        },
        "generalSettings": {
            "showRegisterButton": true,
            "gamesPreviewConfig": {
                "enabledOnPC": false,
                "shouldDisplayJackpot": true
            }
        },
        "miniOrbit": {
            "/cip": {
                "arenasHeaderButtons": [
                    {
                        "title": "LOBBY",
                        "link": "/cip",
                        "icon": assetsMap.images.mini_orbit.arenas_header_buttons.my_casino_icon_png.toString()
                    },
                    {
                        "title": "SLOTS",
                        "link": "/cip/slots",
                        "icon": assetsMap.images.mini_orbit.arenas_header_buttons.slots_icon_png.toString()
                    },
                    {
                        "title": "JACKPOTS",
                        "link": "/cip/jackpots",
                        "icon": assetsMap.images.mini_orbit.arenas_header_buttons.jackpots_icon_png.toString()
                    },
                    {
                        "title": "LIVE_CASINO",
                        "link": "/cip/live-casino",
                        "icon": assetsMap.images.mini_orbit.arenas_header_buttons.live_icon_png.toString()
                    },
                    {
                        "title": "CASINO_GAMES",
                        "link": "/cip/casino-games",
                        "icon": assetsMap.images.mini_orbit.arenas_header_buttons.casino_games_icon_png.toString()
                    }
                ]
            },
            "/cis": {
                "arenasHeaderButtons": [
                    {
                        "title": "LOBBY",
                        "link": "/cis",
                        "icon": assetsMap.images.mini_orbit.arenas_header_buttons.my_casino_icon_png.toString()
                    },
                    {
                        "title": "SLOTS",
                        "link": "/cis/slots",
                        "icon": assetsMap.images.mini_orbit.arenas_header_buttons.slots_icon_png.toString()
                    },
                    {
                        "title": "CASINO_GAMES",
                        "link": "/cis/casino-games",
                        "icon": assetsMap.images.mini_orbit.arenas_header_buttons.casino_games_icon_png.toString()
                    },
                    {
                        "title": "LIVE_CASINO",
                        "link": "/cis/live-casino",
                        "icon": assetsMap.images.mini_orbit.arenas_header_buttons.live_icon_png.toString()
                    },
                    {
                        "title": "JACKPOTS",
                        "link": "/cis/jackpots",
                        "icon": assetsMap.images.mini_orbit.arenas_header_buttons.jackpots_icon_png.toString()
                    }
                ]
            }
        },
        "theme": {
            "name": "casino888"
        },
        "arenas": {
            "slots": {
                "promotionalBanner": {
                    "displayListPlace": 4
                },
                "advancedFilters": {
                    "categories": [
                        {
                            "id": "volatility",
                            "excludedFilters": []
                        },
                        {
                            "id": "features"
                        },
                        {
                            "id": "hasJackpot"
                        },
                        {
                            "id": "themes"
                        },
                        {
                            "id": "vendors"
                        }
                    ]
                }
            },
            "casinoGames": {
                "advancedFilters": {
                    "categories": [
                        {
                            "id": "gameGroups"
                        },
                        {
                            "id": "features"
                        },
                        {
                            "id": "hasJackpot"
                        },
                        {
                            "id": "vendors"
                        }
                    ]
                }
            },
            "videoSlidesArena": {
                "advancedFilters": {
                    "categories": [
                        {
                            "id": "gameGroups"
                        },
                        {
                            "id": "features"
                        },
                        {
                            "id": "hasJackpot"
                        },
                        {
                            "id": "vendors"
                        },
                        {
                            "id": "themes"
                        }
                    ]
                },
                "slidesRules": [
                    {
                        "category": "videoStream",
                        "slidesChunkSize": 8
                    },
                    {
                        "category": "liveStream",
                        "slidesChunkSize": 2
                    },
                    {
                        "category": "banner",
                        "slidesChunkSize": 1
                    },
                ],
                "filters": [
                    {
                        "translationKey": "FREE_SPINS",
                        "category": "features",
                        "id": "freeSpins",
                    },
                    {
                        "translationKey": "Fish",
                        "category": "themes",
                        "id": "theme_fish",
                    },
                    {
                        "translationKey": "JACKPOT",
                        "category": "hasJackpot",
                        "id": "has-jackpot",
                    },
                    {
                        "translationKey": "888 Exclusive",
                        "category": "vendor",
                        "id": "vendor_888",
                    },
                    {
                        "translationKey": "Pragmatic",
                        "category": "vendors",
                        "id": "vendor_pragmatic",
                    },
                    {
                        "translationKey": "Games Global",
                        "category": "vendors",
                        "id": "vendor_gamesglobal",
                    },
                    {
                        "translationKey": "Blueprint",
                        "category": "vendors",
                        "id": "vendor_blueprint",
                    },
                    {
                        "translationKey": "Greek Mythology",
                        "category": "themes",
                        "id": "theme_greek_mythology",
                    }
                ],
                "swiperAnimation": {
                    "triggerDelay": 3000,
                    "individualAnimationDuration": 1.5,
                    "animationAppearances": 1
                }
            },
            "exclusive888Games": {
                "advancedFilters": {
                    "categories": [
                        {
                            "id": "volatility"
                        },
                        {
                            "id": "gameGroups"
                        },
                        {
                            "id": "features"
                        },
                        {
                            "id": "hasJackpot"
                        },
                        {
                            "id": "themes"
                        }
                    ]
                }
            },
            "newLiveCasinoAB": {
                "advancedFilters": {
                    "categories": [
                        {
                            "id": "vendors"
                        },
                        {
                            "id": "hasJackpot"
                        }
                    ]
                }
            }
        },
        "homePage": {
            "menuItemsOverride": {
                "liveCasinoMenuItem": {
                    "menuItemIcon": assetsMap.images.arenas.HomePage.livecasino_header_arena_icon_png.toString()
                },
                "slotsMenuItem": {
                    "menuItemIcon": assetsMap.images.arenas.HomePage.slots_header_arena_icon_png.toString()
                },
                "newGamesMenuItem": {
                    "menuItemIcon": assetsMap.images.arenas.HomePage.newgames_header_arena_icon_png.toString()
                },
                "jackpotsMenuItem": {
                    "menuItemIcon": assetsMap.images.arenas.HomePage.jackpots_header_arena_icon_png.toString()
                },
                "exclusive888arenaMenuItem": {
                    "menuItemIcon": assetsMap.images.arenas.HomePage._888exclusive_header_arena_icon_png.toString()
                },
                "casinoMenuItem": {
                    "menuItemIcon": assetsMap.images.arenas.HomePage.casinogames_header_arena_icon_png.toString()
                },
                "rouletteMenuItem": {
                    "menuItemIcon": assetsMap.images.arenas.HomePage.roulette_header_arena_icon_png.toString()
                },
                "blackjackMenuItem": {
                    "menuItemIcon": assetsMap.images.arenas.HomePage.blackjack_header_arena_icon_png.toString()
                },
                "scratchCardsMenuItem": {
                    "menuItemIcon": assetsMap.images.arenas.HomePage.scratchcards_header_arena_icon_png.toString()
                },
                "videoPokerMenuItem": {
                    "menuItemIcon": assetsMap.images.arenas.HomePage.videopoker_header_arena_icon_png.toString()
                },
                "gameShowsMenuItem": {
                    "menuItemIcon": assetsMap.images.arenas.HomePage.livegameshows_header_arena_icon_png.toString()
                }
            },
        },
        "links": {
            //Orbit links
            "homeLink": "/",
            "jackpotsLink": "/jackpots/",
            "slotsLink": "/slots/",
            "progressiveVideoSlotsLink": "/progressive-video-slots/",
            "newGamesLink": "/new-games/",
            "exclusive888arenaLink": "/888-exclusive-games/",
            "casinoGamesLink": "/casino-games/",
            "liveCasinoLink": "/live-casino/",
            "gameShowsLink": "/live-casino/#filters=live-game-shows",
            "scratchCardsLink": "/scratch-cards/",
            "rouletteLink": "/roulette/",
            "blackjackLink": "/blackjack/",
            "videoPokerLink": "/video-poker/",
            "virtualSportsLink": "/virtual-sports/",
            "instantWinGamesLink": "/instant-win-games/",
            "gamingHistoryLink": "/gaming-history/",
            "jpBetHistoryLink": "/jackpot-bet-history/",
            "gamingSessionHistoryLink": "/session-history/",
            "tippingHistoryLink": "/tipping-history/",
            "openBetsLink": "/open-bets",
            "videoSlideExploreLink": "/video-slides/",

            //B2C links
            "promotionsLink": "/promotions/",
            "promotionsCISLink": "",
            "promotionsCIPLink": "",
            "vipClubLink": "/vipcasinoclub/",
            "vipLink": "/vip/",
            "gettingStartedLink": "/getting-started/",
            "bankingLink": "/banking/",
            "blogLink": "",

            //Brands links
            "casinoLink": "",
            "pokerLink": "",
            "sportLink": "",
            "888clubLink": "",
            "888SiteLink": "",
            "sicomLink": "",
            "sitixLink": "",
            "sishopLink": "",

            //Responsible gaming links
            "responsibleGamingLink": {
                "url": "",
                "shouldAppendSCutToUrl": false,
                "openMode": "newTab"
            },
            "secondaryResponsibleGamingLink": {
                "url": "",
                "shouldAppendSCutToUrl": false,
                "openMode": "newTab"
            },
            "gameCareLink": {
                "url": "https://www.gamcare.org.uk/",
                "shouldAppendSCutToUrl": false
            },
            "beGambleAwareLink": {
                "url": "https://www.begambleaware.org/",
                "shouldAppendSCutToUrl": false
            },
            "safeToPlayLink": {
                "url": "/safe-to-play/",
                "shouldAppendSCutToUrl": false,
                "openMode": "newTab"
            },
            "selfExclusionLink": {
                "url": "",
                "shouldAppendSCutToUrl": false,
                "openMode": "newTab"
            },
            "selfTestLink": {
                "url": "",
                "shouldAppendSCutToUrl": false,
                "openMode": "newTab"
            },

            //Mobile app links
            "downloadAppLink": "",
            "mobileAppsLink": "",
            "appsLandingPageLink": {
                "url": "",
                "openMode": "redirect",
            },

            //other links
            "chatLink": {
                "urlBuilderStrategy": "useGNWP"
            },
            "helpLink": {
                "urlBuilderStrategy": "useGNWP"
            },
            "contactUsLink": {
                "urlBuilderStrategy": "useGNWP"
            },
            "gamblingCommissionLink": {
                "url": "https://www.gamblingcommission.gov.uk/public-register/business/detail/39028",
                "shouldAppendSCutToUrl": false,
                "openMode": "newTab"
            },
        },
        "menuItems": {
            "signUpMenuItem": {
                "text": "SIGN_UP",
                "dl": "19518"
            },
            "loyaltyIndicatorMenuItem": {
                "display": false
            },
            "myClubMenuItem": {
                "text": "MY_CLUB",
                "menuItemIcon": "sideMenuClub888"
            },
            "888clubMenuItem": {
                "text": "888CLUB",
                "linkId": "888clubLink",
                "menuItemIcon": "sideMenuClub888"
            },
            "homeMenuItem": {
                "text": "HOME",
                "linkId": "homeLink",
                "menuItemIcon": "sideMenuHome"
            },
            "jackpotsMenuItem": {
                "text": "INFO_TITLE_ARENA_JACKPOTS",
                "linkId": "jackpotsLink",
                "menuItemIcon": "sideMenuJackpots"
            },
            "slotsMenuItem": {
                "text": "SLOTS",
                "linkId": "slotsLink",
                "menuItemIcon": "sideMenuSlots"
            },
            "newGamesMenuItem": {
                "text": "INFO_TITLE_ARENA_NEW_GAMES",
                "linkId": "newGamesLink",
                "menuItemIcon": "sideMenuNewGames"
            },
            "exclusive888arenaMenuItem": {
                "text": "EXCLUSIVE",
                "linkId": "exclusive888arenaLink",
                "menuItemIcon": "sideMenuExclusive888"
            },
            "casinoMenuItem": {
                "text": "CASINO_GAMES",
                "linkId": "casinoGamesLink",
                "menuItemIcon": "sideMenuCasinoGames"
            },
            "liveCasinoMenuItem": {
                "text": "LIVE_CASINO",
                "linkId": "liveCasinoLink",
                "menuItemIcon": "sideMenuLiveCasino"
            },
            "gameShowsMenuItem": {
                "text": "GAME_SHOWS",
                "linkId": "gameShowsLink"
            },
            "progressiveVideoSlotsMenuItem": {
                "text": "PROGRESSIVE_SLOTS",
                "linkId": "progressiveVideoSlotsLink"
            },
            "scratchCardsMenuItem": {
                "text": "SCRATCHCARDS",
                "linkId": "scratchCardsLink",
                "menuItemIcon": "sideMenuScratchCards"
            },
            "rouletteMenuItem": {
                "text": "ROULETTE",
                "linkId": "rouletteLink",
                "menuItemIcon": "sideMenuRoulette"
            },
            "blackjackMenuItem": {
                "text": "BLACKJACK",
                "linkId": "blackjackLink",
                "menuItemIcon": "sideMenuBlackjack"
            },
            "videoPokerMenuItem": {
                "text": "VIDEO_POKER",
                "linkId": "videoPokerLink",
                "menuItemIcon": "sideMenuVideoPoker"
            },
            "vipMenuItem": {
                "text": "VIP",
                "linkId": "vipLink",
                "menuItemIcon": "sideMenuVip"
            },
            "vipClubMenuItem": {
                "text": "VIP_CLUB",
                "linkId": "vipClubLink",
                "menuItemIcon": "sideMenuVip"
            },
            "gettingStartedMenuItem": {
                "text": "GETTING_STARTED",
                "linkId": "gettingStartedLink",
                "menuItemIcon": "sideMenuGettingStarted"
            },
            "bankingMenuItem": {
                "text": "BANKING",
                "linkId": "bankingLink",
                "menuItemIcon": "sideMenuBanking"
            },
            "depositMenuItem": {
                "text": "DEPOSIT_SIDE_MENU",
                "menuItemIcon": "sideMenuDeposit",
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "IsAuthorized",
                                    "operator": "equal",
                                    "value": true
                                },
                                {
                                    "id": "deviceType",
                                    "operator": "equal",
                                    "value": "mobile"
                                }
                            ],
                            "value": true
                        }
                    ]
                }
            },
            "promotionsMenuItem": {
                "text": "PROMOTIONS",
                "linkId": "promotionsLink",
                "menuItemIcon": "sideMenuPromotions"
            },
            "promotionsCIPMenuItem": {
                "text": "PROMOTIONS",
                "linkId": "promotionsCIPLink",
                "menuItemIcon": "sideMenuPromotions",
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "_IsCIP",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": true
                        }
                    ]
                }
            },
            "promotionsCISMenuItem": {
                "text": "PROMOTIONS",
                "linkId": "promotionsCISLink",
                "menuItemIcon": "sideMenuPromotions",
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "_IsCIS",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": true
                        }
                    ]
                }
            },
            "historyMenuItem": {
                "text": "HISTORY",
                "menuItemIcon": "historyIcon"
            },
            "gamingHistoryMenuItem": {
                "text": "GAMING_HISTORY",
                "linkId": "gamingHistoryLink",
                "menuItemIcon": "gamingHistoryIcon"
            },
            "jpBetHistoryMenuItem":{
                "text": "JACKPOT_BET_HISTORY",
                "linkId": "jpBetHistoryLink",
                "menuItemIcon": "gamingHistoryIcon"
            },
            "gamingSessionHistoryMenuItem": {
                "text": "MENU_ITEM_GAMING_SESSION_HISTORY",
                "linkId": "gamingSessionHistoryLink",
                "menuItemIcon": "gamingHistoryIcon"
            },
            "casinoCrossBrandMenuItem": {
                "text": "casino",
                "linkId": "casinoLink",
                "menuItemIcon": "appHeaderCasinoIcon",
                "display": false
            },
            "pokerCrossBrandMenuItem": {
                "text": "888POKER",
                "linkId": "pokerLink",
                "menuItemIcon": "sideMenuPokerChip",
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "deviceType",
                                    "operator": "equal",
                                    "value": "mobile"
                                }
                            ],
                            "value": true
                        }
                    ]
                }
            },
            "sportCrossBrandMenuItem": {
                "text": "888SPORT",
                "linkId": "sportLink",
                "menuItemIcon": "sideMenuSportFootball",
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "deviceType",
                                    "operator": "equal",
                                    "value": "mobile"
                                }
                            ],
                            "value": true
                        }
                    ]
                }
            },
            "blogMenuItem": {
                "text": "BLOG",
                "linkId": "blogLink",
                "menuItemIcon": "sideMenuBlog"
            },
            "chatMenuItem": {
                "text": "LIVE_CHAT",
                "linkId": "chatLink",
                "menuItemIcon": "sideMenuLiveChat",
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "_IsChatEligible",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": true
                        }
                    ]
                }
            },
            "installPWAMenuItem": {
                "text": "PWA_ADD_TO_HOME_SCREEN",
                "menuItemIcon": "sideMenuDownloadApp",
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "isPWAInstallable",
                                    "operator": "equal",
                                    "value": true
                                },
                                {
                                    "id": "operationSystem",
                                    "operator": "equal",
                                    "value": "android"
                                },
                                {
                                    "id": "_IsUkOrIrl",
                                    "operator": "equal",
                                    "value": "false"
                                },
                                {
                                    "id": "_IsAppBannerUKorIRL",
                                    "operator": "equal",
                                    "value": "false"
                                }
                            ],
                            "value": true
                        }
                    ]
                }
            },
            "downloadAppMenuItem": {
                "text": "DOWNLOAD_APP",
                "linkId": "downloadAppLink",
                "menuItemIcon": "sideMenuDownloadApp"
            },
            "mobileAppsMenuItem": {
                "text": "DOWNLOAD_APP",
                "linkId": "mobileAppsLink",
                "menuItemIcon": "mobileAppsIcon",
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "deviceType",
                                    "operator": "equal",
                                    "value": "mobile"
                                },
                                {
                                    "id": "isHybrid",
                                    "operator": "equal",
                                    "value": false
                                }
                            ],
                            "value": true
                        }
                    ]
                }
            },
            "appsLandingPageMenuItem": {
                "text": "Apps",
                "menuItemIcon": "mobileAppsIcon",
                "linkId": "appsLandingPageLink",
                "display": false
            },
            "transactionHistoryMenuItem": {
                "text": "TRANSACTION_HISTORY",
                "menuItemIcon": "transactionHistoryIcon",
                "display": {
                    "defaultValue": true,
                    "statements": [
                        {
                            "condition": "OR",
                            "rules": [
                                {
                                    "id": "isMiniOrbit",
                                    "operator": "=",
                                    "value": true
                                }
                            ],
                            "value": false
                        }
                    ]
                }
            },
            "cashierUploadDocumentsMenuItem": {
                "text": "UPLOAD_DOCUMENTS",
                "menuItemIcon": "uploadDocumentsIcon",
                "display": {
                    "defaultValue": true,
                    "statements": [
                        {
                            "condition": "OR",
                            "rules": [
                                {
                                    "id": "isMiniOrbit",
                                    "operator": "=",
                                    "value": true
                                }
                            ],
                            "value": false
                        }
                    ]
                }
            },
            "tippingHistoryMenuItem": {
                "text": "TIPPING_HISTORY",
                "menuItemIcon": "tippingHistoryIcon",
                "linkId": "tippingHistoryLink",
                "display": {
                    "defaultValue": true,
                    "statements": [
                        {
                            "condition": "OR",
                            "rules": [
                                {
                                    "id": "isMiniOrbit",
                                    "operator": "=",
                                    "value": true
                                }
                            ],
                            "value": false
                        }
                    ]
                }
            },
            "helpCenterMenuItem": {
                "text": "HELP_CENTER",
                "menuItemIcon": "helpCenterIcon",
                "display": {
                    "defaultValue": true,
                    "statements": [
                        {
                            "condition": "OR",
                            "rules": [
                                {
                                    "id": "isMiniOrbit",
                                    "operator": "=",
                                    "value": true
                                },
                                {
                                    "id": "deviceType",
                                    "operator": "equal",
                                    "value": "mobile"
                                }
                            ],
                            "value": false
                        }
                    ]
                }
            },
            "gameCareMenuItem": {
                "text": "",
                "imageOnlyRendering": true,
                "linkId": "gameCareLink",
                "menuItemIconSource": "themeImages",
                "menuItemIcon": assetsMap.images.responsible_gambling.gamecare_logo_png.toString(),
                "menuItemIconAltText": "GameCare",
                "display": {
                    "defaultValue": true,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "isMiniOrbit",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": false
                        }
                    ]
                }
            },
            "beGambleAwareMenuItem": {
                "text": "",
                "imageOnlyRendering": true,
                "linkId": "beGambleAwareLink",
                "menuItemIconSource": "themeImages",
                "menuItemIcon": assetsMap.images.responsible_gambling.begambleaeare_logo_png.toString(),
                "menuItemIconAltText": "BeGambleAware.org",
                "display": {
                    "defaultValue": true,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "isMiniOrbit",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": false
                        }
                    ]
                }
            },
            "controlCenterMenuItem": {
                "text": "SAFE_ZONE",
                "menuItemIconSource": "themeIcons",
                "menuItemIcon": "controlCenterIcon",
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "deviceType",
                                    "operator": "equal",
                                    "value": "mobile"
                                },
                                {
                                    "id": "regulationID",
                                    "operator": "equal",
                                    "value": 255
                                },
                                {
                                    "id": "isMiniOrbit",
                                    "operator": "equal",
                                    "value": false
                                }
                            ],
                            "value": true
                        }
                    ]
                }
            },
            "timeSpentReminderMenuItem": {
                "text": "TSR_MENU_LINK_LABEL",
                "menuItemIcon": "timerIcon",
                "display": {
                    "defaultValue": true,
                    "statements": [
                        {
                            "condition": "AND",
                            "rules": [
                                {
                                    "id": "isMiniOrbit",
                                    "operator": "equal",
                                    "value": true
                                }
                            ],
                            "value": false
                        }
                    ]
                }
            },
            "compPointsMenuItem": {
                "text": "COMP_POINTS",
                "menuItemIcon": "compPointsIcon",
                "display": {
                    "defaultValue": true,
                    "statements": [
                        {
                            "condition": "OR",
                            "rules": [
                                {
                                    "id": "_IsCIP",
                                    "operator": "=",
                                    "value": true
                                },
                                {
                                    "id": "isMiniOrbit",
                                    "operator": "=",
                                    "value": true
                                }
                            ],
                            "value": false
                        }
                    ]
                }
            },
            "reverseWithdrawalMenuItem": {
                "text": "REVERSE_WITHDRAWAL",
                "menuItemIcon": "reverseWithdrawalIcon",
                "display": {
                    "defaultValue": false,
                    "statements": [
                        {
                            "condition": "OR",
                            "rules": [
                                {
                                    "id": "isMiniOrbit",
                                    "operator": "=",
                                    "value": true
                                }
                            ],
                            "value": false
                        }
                    ]
                }
            },
            "inactivityTimeoutSettingsMenuItem": {
                "text": "MENU_ITEM_INACTIVITY_TIMEOUT_SETTINGS",
                "menuItemIcon": "timerIcon"
            },
            "aboutDialogMenuItem": {
                "text": "MENU_ITEM_ABOUT",
                "menuItemIcon": "aboutIcon"
            },
            "hybridInfoMenuItem": {
                "text": "MENU_ITEM_HYBRID_INFO"
            },
            "pushNotificationsPermissionsRequest": {
                "text": "",
                "display": false,
            },
            "testRegulationSpecificMenuItem": { //this menu item is here for demo purposes
                "text": "Temp test",
                "display": false
            },
            "logoutMenuItem": {
                "text": "LOGOUT"
            },
            "openBetsMenuItem": {
                "text": "OPEN_BETS",
                "menuItemIcon": "openBetsIcon",
                "linkId": "openBetsLink",
                "display": true
            },
            "videoSlideExploreMenuItem": {
                "text": "EXPLORE",
                "menuItemIcon": "exploreOutlinedIcon",
                "linkId": "videoSlideExploreLink",
                "display": false
            }

        },
        "sideMenu": {
            "menuItemsOverride": {
                "sportCrossBrandMenuItem": {
                    "menuItemIcon": "colorfulCrossSport"
                },
                "pokerCrossBrandMenuItem": {
                    "menuItemIcon": "colorfulCrossPoker"
                },
                "depositMenuItem": {
                    "menuItemIcon": "colorfulDeposit"
                },
                "bankingMenuItem": {
                    "menuItemIcon": "colorfulBanking"
                },
                "gettingStartedMenuItem": {
                    "menuItemIcon": "colorfulGettingStarted"
                },
                "promotionsMenuItem": {
                    "menuItemIcon": "colorfulPromotions"
                },
                "homeMenuItem": {
                    "menuItemIcon": "colorfulHome"
                },
                "newGamesMenuItem": {
                    "menuItemIcon": "colorfulNewGames"
                },
                "liveCasinoMenuItem": {
                    "menuItemIcon": "colorfulLiveCasino"
                },
                "rouletteMenuItem": {
                    "menuItemIcon": "colorfulRoulette"
                },
                "slotsMenuItem": {
                    "menuItemIcon": "colorfulSlots"
                },
                "blackjackMenuItem": {
                    "menuItemIcon": "colorfulBlackjack"
                },
                "casinoMenuItem": {
                    "menuItemIcon": "colorfulCasinoGames"
                },
                "jackpotsMenuItem": {
                    "menuItemIcon": "colorfulJackpots"
                },
                "exclusive888arenaMenuItem": {
                    "menuItemIcon": "colorfulExclusive888"
                },
                "videoPokerMenuItem": {
                    "menuItemIcon": "colorfulVideoPoker"
                },
                "scratchCardsMenuItem": {
                    "menuItemIcon": "colorfulScratchCards"
                },
                "vipMenuItem": {
                    "menuItemIcon": "colorfulVip"
                },
                "vipClubMenuItem": {
                    "menuItemIcon": "colorfulVip"
                },
                "blogMenuItem": {
                    "menuItemIcon": "colorfulBlog"
                },
                "chatMenuItem": {
                    "menuItemIcon": "colorfulLiveChat"
                },
                "myClubMenuItem": {
                    "menuItemIcon": "colorfulClub888"
                },
                "888clubMenuItem": {
                    "menuItemIcon": "colorfulClub888"
                },
                "mobileAppsMenuItem": {
                    "menuItemIcon": "colorfulApps"
                }
            }
        },
        "tabsNavigation": {
            "menuItemsOverride": {
                "sportCrossBrandMenuItem": {
                    "menuItemIcon": "colorfulCrossSport"
                },
                "pokerCrossBrandMenuItem": {
                    "menuItemIcon": "colorfulCrossPoker"
                },
                "depositMenuItem": {
                    "menuItemIcon": "colorfulDeposit"
                },
                "bankingMenuItem": {
                    "menuItemIcon": "colorfulBanking"
                },
                "gettingStartedMenuItem": {
                    "menuItemIcon": "colorfulGettingStarted"
                },
                "promotionsMenuItem": {
                    "menuItemIcon": "colorfulPromotions"
                },
                "homeMenuItem": {
                    "menuItemIcon": "colorfulHome"
                },
                "newGamesMenuItem": {
                    "menuItemIcon": "colorfulNewGames"
                },
                "liveCasinoMenuItem": {
                    "menuItemIcon": "colorfulLiveCasino"
                },
                "rouletteMenuItem": {
                    "menuItemIcon": "colorfulRoulette"
                },
                "slotsMenuItem": {
                    "menuItemIcon": "colorfulSlots"
                },
                "blackjackMenuItem": {
                    "menuItemIcon": "colorfulBlackjack"
                },
                "casinoMenuItem": {
                    "menuItemIcon": "colorfulCasinoGames"
                },
                "jackpotsMenuItem": {
                    "menuItemIcon": "colorfulJackpots"
                },
                "exclusive888arenaMenuItem": {
                    "menuItemIcon": "colorfulExclusive888"
                },
                "videoPokerMenuItem": {
                    "menuItemIcon": "colorfulVideoPoker"
                },
                "scratchCardsMenuItem": {
                    "menuItemIcon": "colorfulScratchCards"
                },
                "vipMenuItem": {
                    "menuItemIcon": "colorfulVip"
                },
                "vipClubMenuItem": {
                    "menuItemIcon": "colorfulVip"
                },
                "blogMenuItem": {
                    "menuItemIcon": "colorfulBlog"
                },
                "chatMenuItem": {
                    "menuItemIcon": "colorfulLiveChat"
                },
                "myClubMenuItem": {
                    "menuItemIcon": "colorfulClub888"
                },
                "888clubMenuItem": {
                    "menuItemIcon": "colorfulClub888"
                },
                "mobileAppsMenuItem": {
                    "menuItemIcon": "colorfulApps"
                }
            }
        },
        "bottomNavigationBar": {
            "webAppFeatureToggle": FeatureToggleStatusEnum.Enabled,
            "menuItemsOrder": [
                "homeMenuItem",
                "liveCasinoMenuItem",
                "videoSlideExploreMenuItem",
                "slotsMenuItem",
                "casinoMenuItem",
                "depositMenuItem"
            ]
        },
        "drawer": {
            "userMenuItems": [],
            "saveGamesWidget": {
                "display": false
            }
        },
        "jackpotToaster": {
            "forGames": {
                "defaultThresholdTitle": "progressive_jackpot_threshold_toaster_title",
                "thresholdsBatches": []
            },
            "forJackpots": {
                [KnownJackpotId.Daily]: {
                    "dropTitle": "daily_jackpot_drop_toaster_title",
                    "defaultThresholdTitle": "daily_jackpot_threshold_toaster_title",
                    "thresholdsBatch": {
                        "gameTypes": [130191],
                        "showGameIcon": false,
                        "thresholds": [
                            {
                                threshold: 10000000,
                                toasterName: 'DAILY_JP_ALERT_100K',
                                contentText: 'jackpot_amount_threshold_text_template5'
                            },
                            {
                                threshold: 9000000,
                                toasterName: 'DAILY_JP_ALERT_90K',
                                contentText: 'jackpot_amount_threshold_text_template7'
                            },
                            {
                                threshold: 8000000,
                                toasterName: 'DAILY_JP_ALERT_80K',
                                contentText: 'jackpot_amount_threshold_text_template6'
                            },
                            {
                                threshold: 7500000,
                                toasterName: 'DAILY_JP_ALERT_75K',
                                contentText: 'jackpot_amount_threshold_text_template5'
                            },
                            {
                                threshold: 6000000,
                                toasterName: 'DAILY_JP_ALERT_60K',
                                contentText: 'jackpot_amount_threshold_text_template4'
                            },
                            {
                                threshold: 5000000,
                                toasterName: 'DAILY_JP_ALERT_50K',
                                contentText: 'jackpot_amount_threshold_text_template3'
                            },
                            {
                                threshold: 4000000,
                                toasterName: 'DAILY_JP_ALERT_40K',
                                contentText: 'jackpot_amount_threshold_text_template2'
                            },
                            {
                                threshold: 2500000,
                                toasterName: 'DAILY_JP_ALERT_25K',
                                contentText: 'jackpot_amount_threshold_text_template1'
                            }
                        ]
                    }

                },
                [KnownJackpotId.Twilight]: {
                    "dropTitle": "twilight_jackpot_drop_toaster_title",
                    "defaultThresholdTitle": "twilight_jackpot_threshold_toaster_title",
                    "thresholdsBatch": {
                        "gameTypes": [130019],
                        "showGameIcon": false,
                        "thresholds": [
                            {
                                threshold: 3000000,
                                toasterName: 'TWILIGHT_JP_ALERT_30K',
                                contentText: 'jackpot_amount_threshold_text_template6'
                            },
                            {
                                threshold: 2000000,
                                toasterName: 'TWILIGHT_JP_ALERT_20K',
                                contentText: 'jackpot_amount_threshold_text_template4'
                            },
                            {
                                threshold: 1500000,
                                toasterName: 'TWILIGHT_JP_ALERT_15K',
                                contentText: 'jackpot_amount_threshold_text_template3'
                            },
                            {
                                threshold: 1200000,
                                toasterName: 'TWILIGHT_JP_ALERT_12K',
                                contentText: 'jackpot_amount_threshold_text_template2'
                            },
                            {
                                threshold: 750000,
                                toasterName: 'TWILIGHT_JP_ALERT_7.5K',
                                contentText: 'jackpot_amount_threshold_text_template1'
                            }
                        ]
                    }
                }
            }
        },
        "jackpotBets": {
            "allowWinBelowBetCelebration": true,
        },
        "clientSettings": {
            "languageSwitcher": {
                "display": false
            },
            "biometricLogin": {
                "display": true
            }
        }
    };
}